import { render, staticRenderFns } from "./ClientHandoff.vue?vue&type=template&id=6259a0ae&scoped=true&"
import script from "./ClientHandoff.vue?vue&type=script&lang=ts&"
export * from "./ClientHandoff.vue?vue&type=script&lang=ts&"
import style0 from "./ClientHandoff.vue?vue&type=style&index=0&id=6259a0ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6259a0ae",
  null
  
)

export default component.exports